import React from 'react';

import { IconWrapper } from '../styled-components';

import { ReactComponent as SopraSteriaWhite } from './sopra-steria-white-icon.svg';
import { ReactComponent as SopraSteriaBlack } from './sopra-steria-black-icon.svg';

type SopraSteriaIconProps = {
  /**
   * Scale the icon relative to a base size of 2rem
   */
  scale?: number;
  /**
   * An alternative text that is read by a screen reader for accessibility purposes.
   */
  altText: string;
  /**
   * If true the icon would have white text instead of black.
   */
  light: boolean;
  theme:any;
};

const SopraSteriaIcon: React.FC<SopraSteriaIconProps> = ({ scale = 1, altText, light,theme }) => {
  return (
    <IconWrapper width={8 * scale} height={1 * scale} aria-label={altText}>
      {theme==="dark" ? <SopraSteriaWhite /> : <SopraSteriaBlack/>}
    </IconWrapper>
  );
};

export default SopraSteriaIcon;